<div class="d-flex" [ngStyle]="minWidthStyle">
  <label>{{ label }}</label>
  <mat-form-field appearance="outline">
    <ng-container *ngIf="!!formControl; else noCtrl">
      <textarea
        matInput
        [formControl]="formControl"
        placeholder="{{ placeholder }}"
        [disabled]="disabled"
        (ngModelChange)="onChangeCallback($event)"
        cdkTextareaAutosize
      ></textarea>
    </ng-container>
    <ng-template #noCtrl>
      <textarea
        matInput
        placeholder="{{ placeholder }}"
        [disabled]="disabled"
        [(ngModel)]="innerValue"
        (ngModelChange)="onChangeCallback($event)"
        cdkTextareaAutosize
      ></textarea>
    </ng-template>
  </mat-form-field>
</div>
